<template>
  <div class="workshopGroup section-main__warp">
    <div class="left section-mian_left tree-line-style">
      <div class="left_title">应急组信息</div>
      <div class="device-tab">
        <div
          v-for="item in tabType"
          :key="item.typeId"
          :class="['tab', curTab == item.prop ? 'active' : '']"
          @click="handleTabClick(item)"
        >
          {{ item.label }}
        </div>
      </div>
      <div v-if="curTab == 'first'" class="left-type_area">
        <workshop-group-tree
          :tree-data="workshopGroupList"
          @on-group-add="workshopGroupAdd"
          @on-group-delete="workshopGroupDel"
          @on-group-update="workshopGroupUpdate"
          @node-click="getCurNodeInfo"
        ></workshop-group-tree>
      </div>
      <div v-show="curTab == 'second'" class="left-type_area">
        <integrated-group-tree
          ref="integratedGroupTree"
          :tree-data="integrateGroupList"
          @on-group-add="integrateGroupAdd"
          @on-group-delete="integrateGroupDel"
          @on-group-update="integrateGroupUpdate"
          @node-click="getIntegrateCurNodeInfo"
        ></integrated-group-tree>
      </div>
      <!-- <el-tabs
        style="height: 100%"
        v-model="curTab"
        @tab-click="handleTabClick"
      >
        <el-tab-pane
          label="车间应急组"
          name="first"
          style="display: flex; height: 92%"
        >
          <workshop-group-tree
            :tree-data="workshopGroupList"
            @on-group-add="workshopGroupAdd"
            @on-group-delete="workshopGroupDel"
            @on-group-update="workshopGroupUpdate"
            @node-click="getCurNodeInfo"
          ></workshop-group-tree>
        </el-tab-pane>
        <el-tab-pane label="综合应急组" name="second">
          <integrated-group-tree
            ref="integratedGroupTree"
            :tree-data="integrateGroupList"
            @on-group-add="integrateGroupAdd"
            @on-group-delete="integrateGroupDel"
            @on-group-update="integrateGroupUpdate"
            @node-click="getIntegrateCurNodeInfo"
          ></integrated-group-tree>
        </el-tab-pane>
      </el-tabs> -->
    </div>
    <div class="right section-mian_right">
      <div
        v-if="curTab === 'first'"
        style="display: flex; flex-direction: column; height: 100%"
      >
        <div class="group-info" v-if="curNodeInfo && curNodeInfo.workShopGroupName">
          <div class="info-wrapper">
            <div class="info-item">
              <p class="info-title">名称:</p>
              <p class="">
                {{ curNodeInfo.workShopGroupName }}
              </p>
            </div>
          </div>
          <div class="info-wrapper">
            <div class="info-item">
              <p class="info-title">组长:</p>
              <p class="info-content">{{ curNodeInfo.workShopDirector }}</p>
            </div>
            <div class="info-item">
              <p class="info-title">组长电话:</p>
              <p class="info-content">
                {{ curNodeInfo.workShopDirectorPhone }}
              </p>
            </div>
          </div>
          <div class="info-wrapper">
            <div class="info-item">
              <p class="info-title">职责:</p>
              <p class="info-content ellipsis">
                {{ curNodeInfo.dutyDesc }}
              </p>
            </div>
          </div>
        </div>

        <div class="filter-form">
          <el-form :inline="true">
            <el-form-item label="姓名">
              <el-input placeholder="请输入" v-model="groupFilter.name"></el-input>
            </el-form-item>
            <el-form-item label="电话">
              <el-input placeholder="请输入" v-model="groupFilter.phone"></el-input>
            </el-form-item>
            <el-form-item label="岗位">
              <el-input placeholder="请输入" v-model="groupFilter.position"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" class="query-btn" @click="handleSearch">
                查询
              </el-button>
              <el-button type="info" @click="handleReset"> 重置 </el-button>
            </el-form-item>
          </el-form>
        </div>
        <div
          style="
            display: flex;
            flex-direction: column;
            flex: 1;
            overflow: hidden;
            padding: 12px;
          "
        >
          <div class="operate-btns">
            <el-button
              type="primary"
              @click="handleAddWorkshopPerosn"
              class="iss-operation-button"
              v-auth="'/workshop/emergency-group:update'"
              icon="el-icon-plus"
              >新增</el-button
            >
            <el-button
              @click="handleDelWorkshopPerson"
              type="info"
              icon="el-icon-delete"
              v-auth="'/workshop/emergency-group:update'"
              :disabled="!selectedWorkshopPeople.length ? true : false"
              >删除</el-button
            >
          </div>
          <el-table
            max-height="100%"
            :data="workshopPersonList"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column label="姓名" prop="name"></el-table-column>
            <el-table-column label="电话" prop="phone"></el-table-column>
            <el-table-column label="工号" prop="workNo"></el-table-column>
            <el-table-column label="岗位" prop="position"></el-table-column>
            <el-table-column label="部门" prop="departmentName"></el-table-column>
            <!-- <el-table-column label="是否在职" prop=""></el-table-column> -->
            <el-table-column label="照片">
              <template slot-scope="{ row }">
                <el-image
                  :src="getImgPath(row.facePicFileCode)"
                  style="height: 25px; width: 50px"
                  :preview-src-list="getSrcList(row.facePicFileCode)"
                >
                  <div slot="error" class="image-slot">
                    <img
                      src="/images/theme/newDark/default.png"
                      alt=""
                      style="height: 25px; width: 50px"
                    />
                  </div>
                </el-image>
                <!-- <img :src="getImgPath(scope.row.fileCode)"
                 @click="showViewer(getImgPath(scope.row.fileCode), $event)"
                 onerror="this.src='/images/theme/newDark/default.png'"
                 style="height: 25px; width: 50px" /> -->
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="page.total">
          <el-row class="tc" style="justify-content: center">
            <el-pagination
              class="page-comp"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :page-size="page.pageSize"
              :total="page.total"
              :current-page="page.currentPage"
              @size-change="sizeChange"
              @current-change="pageChange"
              @prev-click="pageChange"
              @next-click="pageChange"
            />
          </el-row>
        </div>
      </div>
      <div v-else style="height: 100%">
        <div class="group-info">
          <div class="info-wrapper">
            <div class="info-item">
              <p class="info-title">名称:</p>
              <p class="">
                {{ curNodeIntegratedInfo.integratedGroupName }}
              </p>
            </div>
          </div>
          <div class="info-wrapper">
            <div class="info-item">
              <p class="info-title">职责:</p>
              <p class="info-content ellipsis">
                {{ curNodeIntegratedInfo.dutyDesc }}
              </p>
            </div>
          </div>
        </div>
        <integrated-table :integratedGroupCode="integratedGroupCode"></integrated-table>
      </div>
    </div>
    <!-- 车间应急组 -->
    <workshop-group-modal
      ref="workshopModal"
      @refresh-workshop-tree="queryWorkshopGroupList"
    ></workshop-group-modal>
    <add-workshop-person
      @refreshData="queryWorkshopPersonList"
      ref="addworkshopPerson"
    ></add-workshop-person>

    <!-- 综合应急组 -->
    <add-integrated-tree
      ref="integratedTree"
      @refresh-tree="queryIntegrateGroupTreeList"
    ></add-integrated-tree>
    <viewer @inited="inited" :images="viewerPhotos" class="viewer" ref="viewer">
      <img v-for="src in viewerPhotos" :src="src" :key="src" />
    </viewer>
  </div>
</template>

<script>
import WorkshopGroupTree from "../components/workshopGroup/workshopGroupTree";
import WorkshopGroupModal from "../components/workshopGroup/workshopGroupModal";
import AddWorkshopPerson from "../components/workshopGroup/addWorkshopPersonModal";
import IntegratedGroupTree from "../components/integratedGroup/integratedGroupTree";
import AddIntegratedTree from "../components/integratedGroup/addIntegratedTree";
import IntegratedTable from "../components/integratedGroup/integratedTable";
import api from "../api";
import { Bus } from "$utils";
export default {
  components: {
    WorkshopGroupTree,
    WorkshopGroupModal,
    AddWorkshopPerson,
    IntegratedGroupTree,
    AddIntegratedTree,
    IntegratedTable,
  },
  data() {
    return {
      viewerInstance: null,
      viewerPhotos: [],
      tabType: [
        // {
        //   label: "专项应急组",
        //   prop: "first",
        // },
        {
          label: "综合应急组",
          prop: "second",
        },
      ],
      // tree data left
      workshopGroupList: [],
      // tree data right
      integrateGroupList: [],
      // table data left
      workshopPersonList: [],
      workShopGroupCode: "",
      curNodeInfo: null,
      curNodeIntegratedInfo: null,
      curTab: "second",
      integratedGroupCode: "",
      selectedWorkshopPeople: [],
      groupFilter: {
        name: "",
        phone: "",
        position: "",
      },
      page: {
        total: 0,
        pageSize: 10,
        currentPage: 1,
      },
    };
  },
  async mounted() {
    await this.queryWorkshopGroupList();
    await this.queryWorkshopPersonList();
    await this.queryIntegrateGroupTreeList();
  },
  methods: {
    inited(viewer) {
      this.viewerInstance = viewer;
    },
    showViewer(src, e) {
      this.viewerPhotos = [
        e.target.src.indexOf("default/default.png") == -1
          ? e.target.src + "&sourceFileFlag=1"
          : e.target.src,
      ];
      this.viewerInstance.show();
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.queryWorkshopPersonList();
    },
    pageChange(pageNo) {
      this.page.currentPage = pageNo;
      this.queryWorkshopPersonList();
    },
    // 查询
    handleSearch() {
      this.queryWorkshopPersonList();
    },
    // 重置
    handleReset() {
      this.groupFilter = {
        name: "", // 人员姓名
        phone: "", // 手机号码
        position: "",
      };
      this.queryWorkshopPersonList();
    },
    // 批量删除勾选
    handleSelectionChange(val) {
      if (!val || !val.length) {
        this.selectedWorkshopPeople = [];
      } else {
        this.selectedWorkshopPeople = val.map((item) => {
          return {
            personnelCode: item.personnelCode,
            workShopGroupCode: item.workShopGroupCode,
          };
        });
      }
    },
    // 获取当前node节点信息
    getCurNodeInfo({ workShopGroupCode, ...rest }) {
      this.workShopGroupCode = workShopGroupCode;
      this.curNodeInfo = rest;
      this.queryWorkshopPersonList();
    },
    // 工作组员工信息
    async queryWorkshopPersonList() {
      const params = {
        name: this.groupFilter.name, // 人员姓名
        phone: this.groupFilter.phone, // 手机号码
        position: this.groupFilter.position, // 岗位
        workShopGroupCode: this.workShopGroupCode, // 车间组code
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
      };
      const loading = this.$loading({
        lock: true,
        text: "请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      const {
        success,
        returnObj: { list, total },
      } = await this.$fetch(api.queryWorkShopGroupInfo, params);
      if (success) {
        setTimeout(() => {
          loading.close();
        }, 500);
        this.workshopPersonList = list;
        this.page.total = total;
      }
    },
    // 车间组树结构
    async queryWorkshopGroupList() {
      try {
        const { success, returnObj } = await this.$fetch(api.queryWorkShopGroup);
        if (success) {
          this.workshopGroupList = returnObj;
          this.workShopGroupCode = returnObj[0].workShopGroupCode;
          this.curNodeInfo = returnObj[0];
        }
      } catch (error) {
        console.error(error);
      }
    },
    workshopGroupAdd(parentCode) {
      this.$refs.workshopModal.show({ parentCode }, 1);
    },
    async workshopGroupDel(data) {
      const confirm = await this.$confirm("确认删除吗?", "提醒");
      if (!confirm) return;
      const keys = this.getCodes([data], "workShopGroupCode", "workShopGroupChildren");
      try {
        const params = {
          workShopGroupCodes: keys,
        };
        const { success, msgContent } = await this.$fetch(
          api.deleteWorkShopGroup,
          params
        );
        if (success) {
          this.queryWorkshopGroupList();
        }
      } catch (error) {
        console.error(error);
      }
    },
    workshopGroupUpdate(groupInfo) {
      this.$refs.workshopModal.show(groupInfo, 2);
    },
    // 构建头像路径
    getImgPath(item) {
      const path = item ? Bus.imgPath(item) : "";
      return path;
    },
    // 头像放大
    getSrcList(code) {
      if (!code) return;
      return [this.getImgPath(code)];
    },
    // 新增车间组人员
    handleAddWorkshopPerosn() {
      const { workShopGroupCode } = this;
      this.$refs.addworkshopPerson.open({ workShopGroupCode });
    },
    // 删除车间组人员
    async handleDelWorkshopPerson() {
      if (!this.selectedWorkshopPeople.length) {
        this.$message.warning("请选择数据");
        return;
      }

      try {
        const res = await this.$confirm("您确定将人员从所属应急组移除吗?", "移除确认", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        });
        if (!res) return;
        const { success, msgContent } = await this.$fetch(
          api.deleteWorkShopGroupInfo,
          this.selectedWorkshopPeople
        );
        if (success) {
          this.queryWorkshopPersonList();
        } else {
          msgContent && this.$message.warning(msgContent);
        }
      } catch (error) {
        console.error(error);
      }
    },
    // 切换tab选项卡
    handleTabClick(tab) {
      this.curTab = tab.prop;
      if (this.curTab == "second") {
        this.$refs.integratedGroupTree.unfoldTree(this.integrateGroupList);
      }
    },
    // 综合应急组
    integrateGroupAdd(parentCode) {
      this.$refs.integratedTree.show({ parentCode }, 1);
    },
    async integrateGroupDel(data) {
      const confirm = await this.$confirm("确认删除吗?", "提醒");
      if (!confirm) return;
      const keys = this.getCodes(
        [data],
        "integratedGroupCode",
        "integratedGroupChildren"
      );
      try {
        const params = {
          integratedGroupCodes: keys,
        };
        const { success, msgContent } = await this.$fetch(
          api.deleteIntegratedGroup,
          params
        );
        if (success) {
          this.queryIntegrateGroupTreeList();
          // this.queryWorkshopGroupList();
        } else {
          this.$message.warning(msgContent);
        }
      } catch (error) {
        console.error(error);
      }
    },
    integrateGroupUpdate(groupInfo) {
      this.$refs.integratedTree.show(groupInfo, 2);
    },
    // 综合组当前选中节点的groupCode
    getIntegrateCurNodeInfo({ integratedGroupCode, ...rest }) {
      this.curNodeIntegratedInfo = rest;
      this.integratedGroupCode = integratedGroupCode;
    },
    // 综合组树数据
    async queryIntegrateGroupTreeList() {
      try {
        const { success, returnObj } = await this.$fetch(api.queryIntegratedGroup);
        if (success) {
          this.integrateGroupList = returnObj;
          this.integratedGroupCode = returnObj[0].integratedGroupCode;
          this.curNodeIntegratedInfo = returnObj[0];
        }
      } catch (error) {
        console.error(error);
      }
    },
    // 获取选中的树的节点及其字节点的code
    getCodes(data, key, childKey) {
      let ret = [];
      data.forEach((item) => {
        if (item[childKey] && item[childKey].length) {
          ret = ret.concat(this.getCodes(item[childKey], key, childKey));
        }
        ret = ret.concat(item[key]);
      });
      return ret;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.workshopGroup {
  // padding: 0 16px;
  display: flex;
  height: calc(100% - 13px);
  .ellipsis {
    overflow-wrap: anywhere;
    width: calc(100% - 100px) !important; //宽度
    overflow: hidden; //超出文本隐藏
    text-overflow: ellipsis; ///超出部分省略号显示
    display: -webkit-box; //弹性盒模型
    -webkit-box-orient: vertical; //上下垂直
    -webkit-line-clamp: 2; //自定义行数
  }
  .left {
    // width: 300px;
    // height: 100%;
    flex-shrink: 0;

    .left_title {
      border-left: 4px solid #407aee;
      padding-left: 8px;
      margin: 16px;
    }
    .device-tab {
      display: flex;
      margin: 0 16px 15px 16px;
      .tab {
        // color: #9aa6c1;
        @include set_theme_color(color, font-default-color);
        flex: 1;
        text-align: center;
        padding-bottom: 10px;
        border-bottom: 1px solid #dcdfe6;
        &:hover {
          @include set_theme_color(color, font-active-color);
          cursor: pointer;
        }
      }
      .active {
        @include set_theme_color(color, font-active-color);
        // color: #fff;
        border-color: #407aee;
      }
    }
    .device-search {
      display: flex;
      margin: 15px 16px;
      height: 28px;
      .el-input {
        width: 100%;
      }
    }
  }
  .right {
    flex: 1;
    height: 100%;
    // padding: 0 20px;
    .filter-form {
      padding: 16px 10px 0;
      margin: 10px 0;
      @include set_theme_color(background-color, left-menu-bg-color);
    }
    .group-info {
      padding: 16px;
      @include set_theme_color(background-color, left-menu-bg-color);
      .title {
        // padding: 0 20px;
        height: 40px;
        line-height: 40px;
        border-bottom: 1px solid #dcdfe6;
      }
      .info-wrapper {
        display: flex;
        padding: 20px 0;
        border-bottom: 1px solid #dcdfe6;
        .info-item {
          display: flex;
          margin-right: 20px;
          .info-title {
            width: 100px;
          }
          .info-content {
            width: 120px;
          }
        }
      }
    }
    .operate-btns {
      margin: 12px 0;
    }
    .page-comp {
      margin: 10px 0;
    }
  }
}
</style>
